import { createWolliMediaProvider } from '@wolliware/wollimedia-client/source';

export function installWolliWordsWolliMediaBridge() {
    window.WolliMediaClient ??= {};
    window.WolliMediaClient.createWolliMediaProvider = createWolliMediaProvider;
}

installWolliWordsWolliMediaBridge();
